export const READY_TO_SEND_EXPERIMENT_PROPERTY = "ready_to_send_experiment_aug2026";
export const PENDING_READY_TO_SEND_ASSIGNMENT_STORAGE_KEY = "bx_pending_ready_to_send_assignment";
export const READY_TO_SEND_VARIANT_PROPERTY = "variant";
export const READY_TO_SEND_TRIGGERED_EVENT_NAME = "ready_to_send_triggered";
export const READY_TO_SEND_MODAL_VIEWED_EVENT_NAME = "ready_to_send_modal_viewed";
export const READY_TO_SEND_MODAL_DISMISSED_EVENT_NAME = "ready_to_send_modal_dismissed";
export const READY_TO_SEND_MODAL_SEND_CLICKED_EVENT_NAME = "ready_to_send_modal_send_clicked";
